import { toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/constants/routes";
import {
  CreateProductionGrainBody,
  createProductionGrain,
} from "@/services/production-grains.service";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { handlePermissionError } from "@/utils/permission-check";
import { NavigateFunction } from "react-router-dom";
import { ProductionGrainCreationForm } from "./production-grain-creation.schema";
import { getBooleanValue } from "@/utils/request-validations";

interface CreateProductionGrainHandlerProps {
  values: ProductionGrainCreationForm;
  setLoadingCreate: (loading: boolean) => void;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const createProductionGrainHandler = async ({
  values,
  setLoadingCreate,
  navigate,
  fetchPermissions,
}: CreateProductionGrainHandlerProps) => {
  const body: CreateProductionGrainBody = {
    nombre: String(values?.nombre ?? "").trim(),
    aplicaPPMB: getBooleanValue(values?.aplicaPPMB),
    granoAdmis: Number(values?.granoAdmis),
    sumaHA: getBooleanValue(values?.sumaHA),
  };

  setLoadingCreate(true);
  try {
    await createProductionGrain(body);

    toaster.create({
      type: "success",
      title: "Grano productivo creado exitosamente.",
    });

    navigate(AppRoutes.PRODUCTION_GRAINS);
  } catch (error) {
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.PRODUCTION_GRAINS,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title: getAxiosErrorMessage(error, "No se pudo crear el grano productivo."),
      });
    }

    throw error;
  } finally {
    setLoadingCreate(false);
  }
};
